export const PAGE_ID = "page";
export const FOOTER_ID = "footer";

/** Make a string safe for using as an `id` prop for a DOM element. */
export const cleanId = (id: string): string => id.replace(/[^a-z0-9-]/g, "");
